import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['filterButton', 'body', 'header'];
  static values = { open: Boolean };

  // 絞り込み中でも条件が畳まれたままだと、何で絞ったのかが画面から分からない
  connect() {
    if (this.openValue) this.#open({ animate: false });
  }

  // action="click->filter-bar#toggle:prevent"
  toggle() {
    if (this.headerTarget.classList.contains('is-open')) {
      this.#close();
    } else {
      this.#open();
    }
  }

  #open({ animate = true } = {}) {
    this.headerTarget.classList.add('is-open');

    // 初期表示では高さが 0 から変わる様子を見せたくないので、その回だけ transition を切る
    if (!animate) this.bodyTarget.style.transition = 'none';
    this.bodyTarget.style.height = `${this.bodyTarget.scrollHeight}px`;
    if (!animate) {
      requestAnimationFrame(() => {
        this.bodyTarget.style.transition = '';
      });
    }

    if (this.hasFilterButtonTarget) {
      this.filterButtonTarget.style.display = 'none';
    }
  }

  #close() {
    this.headerTarget.classList.remove('is-open');
    this.bodyTarget.style.height = '0';

    if (this.hasFilterButtonTarget) {
      this.filterButtonTarget.style.display = 'block';
    }
  }
}
